import { render, staticRenderFns } from "./OrganisationMemberRoleChange.vue?vue&type=template&id=6b2fdae0&scoped=true"
import script from "./OrganisationMemberRoleChange.vue?vue&type=script&lang=js"
export * from "./OrganisationMemberRoleChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2fdae0",
  null
  
)

export default component.exports